<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'

}
</script>
<style lang="scss">
  @import './styles/index.scss'; // 全局自定义的css样式
</style>
